import { render, staticRenderFns } from "./bigTurntable_A.vue?vue&type=template&id=5d650af3&scoped=true&"
import script from "./bigTurntable_A.vue?vue&type=script&lang=js&"
export * from "./bigTurntable_A.vue?vue&type=script&lang=js&"
import style0 from "./bigTurntable_A.vue?vue&type=style&index=0&id=5d650af3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d650af3",
  null
  
)

export default component.exports